<div class="color-item"
     [class.opaque]="!color.highlighted"
     [style.background-color]="color.colorHex"
     (click)="selectColor(); $event.stopPropagation();">
  <div *ngIf="color.selected"></div>
</div>
